var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('h1',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }